import { render, staticRenderFns } from "./Dialog-notice.vue?vue&type=template&id=6fcb91d2&scoped=true&"
import script from "./Dialog-notice.vue?vue&type=script&lang=js&"
export * from "./Dialog-notice.vue?vue&type=script&lang=js&"
import style0 from "./Dialog-notice.vue?vue&type=style&index=0&id=6fcb91d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb91d2",
  null
  
)

export default component.exports